import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AButtonCancelComponent } from './a-button-cancel/a-button-cancel.component';
import { AButtonDefaultComponent } from './a-button-default/a-button-default.component';
import { AButtonSubmitComponent } from './a-button-submit/a-button-submit.component';
import { AButtonIconComponent } from './a-button-icon/a-button-icon.component';
import { AButtonCloseComponent } from './a-button-close/a-button-close.component';

const components = [
    AButtonCancelComponent,
    AButtonDefaultComponent,
    AButtonSubmitComponent,
    AButtonCloseComponent,
    AButtonIconComponent
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule
    ],
    declarations: components,
    exports: components
})
export class ButtonsModule {
}
